import { Component, Output, EventEmitter } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
    selector: 'app-admin-login',
    imports: [FormsModule],
    templateUrl: './admin-login.component.html',
    styleUrl: './admin-login.component.css'
})
export class AdminLoginComponent {
  secret = '';
  error = '';
  @Output() loginSuccess = new EventEmitter<void>();

  constructor(private router: Router) { }

  login() {
    if (!this.secret) {
      this.error = 'Please enter a secret';
      return;
    }
    localStorage.setItem('admin-secret', this.secret);
    this.loginSuccess.emit();
  }
}
